import React, { Component } from "react";
import { Link } from "react-router-dom";

//import SignHeader from "../component/SignHeader";
import SignHeader from "../component/HeaderAudioBook";
import { instanceOf } from 'prop-types';
import cookie from 'react-cookie';

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

import "../scss/style.scss";
import "../scss/sign.scss";

class Home extends Component {
	

	constructor(props) {
		super(props);
		//const [open, setOpen] = React.useState(false);
		this.state = { headerTitle: "더책", self: this, open: false };

		this.doOpenAlert = this.doOpenAlert.bind(this);
		this.doCloseAlert = this.doCloseAlert.bind(this);

	}

	handleChange(event) {
		
		const query = event.target.value;

		console.log(event.target.value);

		if (query === "더책") {
			this.setState({ open: true });
			//alert("프로모션 코드 인증에 성공하였습니다.");

			//const { cookies } = this.props;

			
		}

	}

	setCookie() {
	    this.setCookie2('더책','10006','2','더책',"1","1","1");
	};

	setCookie2(userid, strdbid, orgid, orgname, logoncount, llendbookcount, sbc) {
		let d = new Date();
		d.setTime(d.getTime() + (12 * 60 * 60 * 1000));
		cookie.save("userid", userid, { path: "/", expires: d });
		cookie.save("userdbid", strdbid, { path: "/", expires: d });
		cookie.save("orgid", orgid, { path: "/", expires: d });
		cookie.save("orgname", orgname, { path: "/", expires: d });
		cookie.save("lc", logoncount, { path: "/", expires: d });
		cookie.save("lendc", llendbookcount, { path: "/", expires: d });
		cookie.save("sbc", sbc, { path: "/", expires: d });
		cookie.save("general_userid", userid, { path: "/", expires: d });
		cookie.save("general_userdbid", strdbid, { path: "/", expires: d });
		cookie.save("general_orgid", orgid, { path: "/", expires: d });
		cookie.save("general_orgname", orgname, { path: "/", expires: d });
		cookie.save("general_lc", logoncount, { path: "/", expires: d });
		cookie.save("general_lendc", llendbookcount, { path: "/", expires: d });
		cookie.save("general_sbc", sbc, { path: "/", expires: d });
	};
	doOpenAlert() {
		//this.setState({ open: true });
		this.state = { headerTitle: "더책", self: this, open: true };
	}

	doCloseAlert() {
		//this.setState({ open: false });

		this.state.self.setCookie();
		
		this.state = { headerTitle: "더책", self: this, open: false };

		window.location = "/HomeAudioBook";


	}



	render() {
		return (
			<React.Fragment>
				<SignHeader headerTitle="더책" />
            <br/><p/>
            <br/><p/>
            <br/><p/>
            <br/><p/>
            <br/><p/>
            <br/><p/>
				<div className="signLayout">
					<div className="form-group">
						<label className="form-label">프로모션 코드</label>
						<input className="form-input form-input-lg" type="text" placeholder="코드를 입력해주세요" onChange={this.handleChange.bind(this)} />
					</div>
				</div>

				<Dialog open={this.state.open} onClose={this.doCloseAlert}>
					<div className="dialog-body">
						<p>코드가 확인되었습니다.</p>
					</div>
					<div className="dialog-footer">
						<button onClick={this.doCloseAlert} color="primary" autoFocus className="btn btn-primary btn-sm">
							OK
					</button>
					</div>
				</Dialog>
			</React.Fragment>
		);
	}
}

export default Home;
